module.exports = JBrowseExports["@jbrowse/core/pluggableElementTypes/ViewType"];